import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom validator function that checks if the password and confirmed password fields match.
 * Returns a validation error object if the passwords do not match.
 * Returns null if the passwords match.
 * @returns A validator function that can be used with Angular Reactive Forms.
 */
export function passwordMatchValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.parent?.value.newPassword ?? control.parent?.value.password;
    if (password) {
      const confirmedPassword = control.value;

      if (password !== confirmedPassword) {
        return { passwordMismatch: true };
      }
    }
    return null;
  };
}
